<template>
<div class='vx-col w-full'>
    <div class="p-2 code-color-1 inline-block hand redondo" @click="f_array_voices()"> <img src="./volume.svg" height="15px"></div>
</div>
</template>

<script>
export default {
    props: {
        datosVoz: {
            type: Object,
            default: function () {
                return {};
            },
        },
        accionVoz:{
            type: Number,
            default: 0,
        }
    },
    components: {},
    data() {
        return {};
    },
    created() {},
    mounted() {
        this.f_inicio();
    },
    methods: {
        f_inicio(){
            // console.log('accionVoz', this.accionVoz)
            if(this.accionVoz > 0) return
            setTimeout(() => {
                // console.log('voces vue linea 28', this.datosVoz)
                this.f_array_voices();
            }, 300)
        },
        f_array_voices() {
            let me = this;
            // console.log('f_array_voices voces vue linea 28', me.datosVoz)
            //0 se usa por defecto para los juegos
            //1 se usa desde EstudianteResponderEvaluacion para enviar la pregunta
            if(this.accionVoz == 0){
                me.f_getVoices(me.datosVoz.nombre)
                me.f_getVoices(me.datosVoz.descripcion)
            }
            if(this.accionVoz == 1){
                me.f_getVoices(me.datosVoz.pregunta)
            }
        },
        f_getVoices(texto) {
            if ('speechSynthesis' in window) {
                const utterance = new SpeechSynthesisUtterance(texto);
                window.speechSynthesis.speak(utterance);
                // console.log(utterance)
            } else {
                alert('Este navegador no está actualizado, no es posible reproducir el audio.');
            }
        },
    }
};
</script>

<style scoped>
.alto-1 {
    height: 35px;
}

.m-izquierdo {
    margin-left: 20px;
}

.code-color-1 {
    background-color: #dfdcdc;
    color: black;
}
</style>
